// Imports for external libraries go here.
import React, { FC, useCallback } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { ConsentCheckListItemProps } from './ConsentCheckListItem.types';
import { StyledConsentCheckListItem } from './ConsentCheckListItem.styles';
import { CheckBox, Link } from '@marriott/mi-ui-library';
import { LegalTextWithLink } from '../LegalTextWithLink';

export const ConsentCheckListItem: FC<ConsentCheckListItemProps> = props => {
  const {
    label,
    errorLabel,
    termsBtnLabel,
    termsLink,
    selectedConsentId,
    id,
    className,
    name,
    isChecked,
    onModalOpen,
    onChange,
    onLinkClickInHeaderOrCheckbox,
    linkClass,
    linkTarget,
    validateErrors,
  } = props;

  const showError = validateErrors && !isChecked;

  const onCheckboxChange = () => {
    onChange(selectedConsentId, id);
  };

  const onTermsModalOpen = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      onModalOpen(termsLink, e);
    },
    [termsLink, onModalOpen] // Dependencies to ensure function isn't recreated unnecessarily
  );

  return (
    <StyledConsentCheckListItem
      onClick={onLinkClickInHeaderOrCheckbox} // Attach click handler to all the anchor tags present within the checkbox label
      data-testid="legal-ConsentCheckListItem"
      data-component-name="m-legal-ConsentCheckListItem"
    >
      <CheckBox
        checkboxId={id}
        checkboxName={name}
        className={className}
        checked={isChecked}
        onChange={onCheckboxChange}
      >
        <LegalTextWithLink descriptionText={label} className="m-checkbox-label" />
        {showError && <LegalTextWithLink descriptionText={errorLabel} className="m-checkbox-error" />}
      </CheckBox>
      {termsLink && (
        <Link
          linkHref={termsLink}
          linkClassName={linkClass}
          target={linkTarget}
          text={termsBtnLabel}
          callback={onTermsModalOpen}
        />
      )}
    </StyledConsentCheckListItem>
  );
};
